import { parse } from 'date-fns';

export const parseDateFormat = 'yyyy-MM-dd';

export const parseDate = (date: string) => {
	return parse(date, parseDateFormat, new Date());
};
